import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var offersInitialState = {
  layout: null,
  contact: null,
  error: false,
  loading: false
};
export function reducer(state, action) {
  var _state$layout, _state$layout2;
  switch (action.type) {
    case 'SET_LAYOUT':
      return _objectSpread(_objectSpread({}, state), {}, {
        layout: action.payload
      });
    case 'SET_LOADING':
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: action.payload
      });
    case 'SET_ERROR':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload
      });
    case 'SET_CONTACT':
      return _objectSpread(_objectSpread({}, state), {}, {
        contact: action.payload
      });
    case 'SET_COMPARISON_STATUS':
      return _objectSpread(_objectSpread({}, state), {}, {
        layout: _objectSpread(_objectSpread({}, state.layout), {}, {
          offers: _toConsumableArray((_state$layout = state.layout) === null || _state$layout === void 0 || (_state$layout = _state$layout.offers) === null || _state$layout === void 0 ? void 0 : _state$layout.map(function (offer) {
            if (offer.id === action.payload.offerId) {
              return _objectSpread(_objectSpread({}, offer), {}, {
                offersComparisonStatus: {
                  status: action.payload.status,
                  description: ''
                }
              });
            }
            return offer;
          }))
        })
      });
    case 'SET_FAVORITE_STATUS':
      return _objectSpread(_objectSpread({}, state), {}, {
        layout: _objectSpread(_objectSpread({}, state.layout), {}, {
          offers: _toConsumableArray((_state$layout2 = state.layout) === null || _state$layout2 === void 0 || (_state$layout2 = _state$layout2.offers) === null || _state$layout2 === void 0 ? void 0 : _state$layout2.map(function (offer) {
            if (offer.id === action.payload.offerId) {
              return _objectSpread(_objectSpread({}, offer), {}, {
                isFavorite: action.payload.isFavorite
              });
            }
            return offer;
          }))
        })
      });
    default:
      return state;
  }
}